import { render, staticRenderFns } from "./CashCollectionReport.vue?vue&type=template&id=48c4e868"
import script from "./CashCollectionReport.vue?vue&type=script&lang=js"
export * from "./CashCollectionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports